import {
  type CountryCode,
  getCountryCallingCode,
  parsePhoneNumberFromString,
} from "libphonenumber-js/max";

/** E.164 form of a phone number, or null when it can't be resolved for the country. */
export const toE164 = (
  value: string | null | undefined,
  countryCode: CountryCode,
): string | null => {
  const trimmed = value?.trim();
  if (!trimmed) {
    return null;
  }

  const parsed = parsePhoneNumberFromString(trimmed, countryCode);

  return parsed?.isValid() ? parsed.number : null;
};

export const diallingCode = (countryCode: CountryCode): string =>
  `+${getCountryCallingCode(countryCode)}`;

// Never prefill a bare national number: Cal.com would guess the country (as Sweden).
export const toE164OrDiallingCode = (
  value: string | null | undefined,
  countryCode: CountryCode,
): string => toE164(value, countryCode) ?? diallingCode(countryCode);
